module.exports = __webpack_public_path__ + "img/pt_get.61868b6.png";